// services/api.js
// In development, use the proxy (relative URL)
// In production, use the full URL
const isDevelopment = process.env.NODE_ENV === 'development';
const API_BASE_URL = isDevelopment 
  ? '/AudioBooksCatalog/api' 
  : '/api';

const api = {
  async getAuthors() {
    const response = await fetch(`${API_BASE_URL}/authors`);
    if (!response.ok) throw new Error('Failed to fetch authors');
    return await response.json();
  },
  
  async getAuthor(authorId) {
    const response = await fetch(`${API_BASE_URL}/authors/${authorId}`);
    if (!response.ok) throw new Error('Failed to fetch author');
    return await response.json();
  },
  
  async getCategories(authorId) {
    const response = await fetch(`${API_BASE_URL}/categories?authorId=${authorId}`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return await response.json();
  },
  
  async getCategory(categoryId) {
    const response = await fetch(`${API_BASE_URL}/categories/${categoryId}`);
    if (!response.ok) throw new Error('Failed to fetch category');
    return await response.json();
  },
  
  async getSubCategories(parentCategoryId) {
    const response = await fetch(`${API_BASE_URL}/categories?parentId=${parentCategoryId}`);
    if (!response.ok) throw new Error('Failed to fetch sub-categories');
    return await response.json();
  },
  
  async getBooks(authorId, categoryId) {
    let url = `${API_BASE_URL}/books?`;
    if (authorId) url += `authorId=${authorId}&`;
    if (categoryId) url += `categoryId=${categoryId}&`;
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch books');
    return await response.json();
  },
  
  async getBook(bookId) {
    const response = await fetch(`${API_BASE_URL}/books/${bookId}`);
    if (!response.ok) throw new Error('Failed to fetch book');
    return await response.json();
  },
  
  async getAudioFiles(bookId) {
    const response = await fetch(`${API_BASE_URL}/books/${bookId}/audio-files`);
    if (!response.ok) throw new Error('Failed to fetch audio files');
    return await response.json();
  },
};

export default api;